import * as React from 'react';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {TooltipPosition} from '../../../../components/Common/Tooltip/types';
import {Tooltip} from '../../../../components/Common/Tooltip';

export type IconName =
    | 'close-icon'
    | 'export-icon'
    | 'star-icon'
    | 'undo-icon'
    | 'delete-icon'
    | 'flag-icon'
    | 'collapse-icon';

interface MenuItem {
    action?: () => void;
    tooltip?: string;
    isDisabled: () => boolean;
    isSelected?: () => boolean;
    //used as a function when the tooltip should update after invoke the item action
    getTooltip?: () => string;
}

interface MenuIconProps {
    item: MenuItem;
    name: IconName;
    tooltipPosition?: TooltipPosition;
    tooltipClassname?: string;
    role?: string;
    primarySkin?: boolean;
}

export const MenuIcon = (props: MenuIconProps) => {
    const {item, name, tooltipPosition, tooltipClassname, primarySkin} = props;
    const tooltip = item && item.getTooltip ? item.getTooltip() : item.tooltip;

    const isSelected = item?.isSelected?.();

    const getIconByName = (name: string) => {
        switch (name) {
            case 'star-icon':
                return PriorityIcon.starEmpty;
            case 'export-icon':
                return PriorityIcon.exportExcel;
            case 'close-icon':
                return PriorityIcon.closeBig;
            case 'undo-icon':
                return PriorityIcon.refresh;
            case 'delete-icon':
                return PriorityIcon.delete;
            case 'flag-icon':
                return PriorityIcon.notification;
            case 'collapse-icon':
                return PriorityIcon.match;
            default:
                return null;
        }
    };

    const getSelectedIcon = (name: string) => {
        let icon: PriorityIcon = null;
        switch (name) {
            case 'star-icon':
                icon = PriorityIcon.starFilled;
                break;
            case 'flag-icon':
                icon = PriorityIcon.notificationFilled;
                break;
        }
        return icon ? (
            <Icon
                icon={icon}
                iconColor="primary-500"
                disabled={item?.isDisabled?.()}
                onClick={item?.action}
            />
        ) : null;
    };

    return (
        <Tooltip tooltip={tooltip} className={tooltipClassname} position={tooltipPosition}>
            {isSelected ? (
                getSelectedIcon(name)
            ) : (
                <Icon
                    icon={getIconByName(name)}
                    skin={primarySkin ? 'primary' : 'standart'}
                    disabled={item?.isDisabled?.()}
                    onClick={item?.action}
                />
            )}
        </Tooltip>
    );
};
